<template>
    <div id="mailinfo">
        <div class="head-tool">
            <span @click="$router.go(-1)">返回</span>
            <span class="tc">个人中心</span>
            <router-link class="tr" tag="span" to="/">首页</router-link>
        </div>
        <div class="info" >
            <h2 class="title">{{info.title}}</h2>
            <p class="time">{{info.create_time}}</p>
            <div v-html="info.content"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Mailinfo",
        data(){
            return  {
                info : {},

            }
        },
        methods : {
            getMailInfo(){
                this.axios.post('/api/mail/getMailInfo',{
                    id : this.$route.params.id
                }).then(r => {
                    let data = r.data;
                    if(data.code){
                        this.info = data.data;

                    }
                })
            }
        },created() {
            this.getMailInfo();
        }
    }
</script>

<style lang="less">
#mailinfo{background: #f6f6f7;overflow: auto;height: 100%;
    .head-tool{display: flex;padding: 26px 20px;background: #fff;border-bottom: 1px solid #efefef;
        span{flex:1;font-size: 30px;color:#333;
            i{font-size: 30px;}
        }
    }

    .info{background: #fff;margin-top: 20px;overflow: auto;padding: 20px;height: 100%;overflow: auto;
        .title{font-size: 34px;color: #333;margin-bottom: 10px;}
        .time{font-size: 24px; color: #999;margin-bottom: 20px;}
    }

}
</style>
